<template>
  <div>
    <h1 class="page-header">
      Dashboard <small>Ringkasan aktivitas bank soal</small>
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-info">
          <div class="stats-icon">
            <font-awesome-icon icon="list-alt" />
          </div>
          <div class="stats-info">
            <h4>JUMLAH SOAL</h4>
            <p>{{ total_questions }}</p>
            <small class="d-block text-white-75"
              >Soal aktif yang tersedia</small
            >
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-lime">
          <div class="stats-icon">
            <font-awesome-icon icon="tasks" />
          </div>
          <div class="stats-info">
            <h4>SUDAH DIREVIEW</h4>
            <p>{{ total_reviewed }}</p>
            <small class="d-block text-white-75"
              >{{ review_progress }}% dari total antrean review</small
            >
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-warning">
          <div class="stats-icon">
            <font-awesome-icon icon="clock" />
          </div>
          <div class="stats-info">
            <h4>BELUM DIREVIEW</h4>
            <p>{{ total_unreviewed }}</p>
            <small class="d-block text-white-75"
              >Perlu tindak lanjut reviewer</small
            >
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-danger">
          <div class="stats-icon">
            <font-awesome-icon icon="book" />
          </div>
          <div class="stats-info">
            <h4>PAKET SOAL</h4>
            <p>{{ total_question_package }}</p>
            <small class="d-block text-white-75">Paket aktif di sistem</small>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-blue">
          <div class="stats-icon">
            <font-awesome-icon icon="file-alt" />
          </div>
          <div class="stats-info">
            <h4>SOAL DRAFT</h4>
            <p>{{ total_draft_questions }}</p>
            <small class="d-block text-white-75"
              >Belum disubmit ke review</small
            >
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-success">
          <div class="stats-icon">
            <font-awesome-icon icon="paper-plane" />
          </div>
          <div class="stats-info">
            <h4>SOAL TERSUBMIT</h4>
            <p>{{ total_submitted_questions }}</p>
            <small class="d-block text-white-75"
              >Siap atau sedang direview</small
            >
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-orange">
          <div class="stats-icon">
            <font-awesome-icon icon="chart-pie" />
          </div>
          <div class="stats-info">
            <h4>PROGRESS REVIEW</h4>
            <p>{{ review_progress }}%</p>
            <small class="d-block text-white-75"
              >{{ total_reviewed }} dari {{ total_review_scope }} soal</small
            >
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-purple">
          <div class="stats-icon">
            <font-awesome-icon icon="clipboard-check" />
          </div>
          <div class="stats-info">
            <h4>UJIAN AKTIF</h4>
            <p>{{ total_active_exams }}</p>
            <small class="d-block text-white-75"
              >{{ total_upcoming_exams }} ujian berikutnya</small
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <div class="panel border-0">
          <div class="panel-heading">
            <h4 class="panel-title">Grafik Soal Berdasarkan Blok</h4>
          </div>
          <div class="panel-body p-3">
            <div ref="barBlock" style="min-height: 463px"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="panel border-0">
          <div
            class="panel-heading d-flex justify-content-between align-items-center"
          >
            <h4 class="panel-title">Ujian Aktif & Terdekat</h4>
          </div>
          <div class="panel-body p-0">
            <div
              v-if="recent_exams.length === 0"
              class="p-3 text-center text-muted"
            >
              Belum ada jadwal ujian yang perlu ditampilkan.
            </div>
            <div v-else class="list-group list-group-flush">
              <div
                v-for="exam in recent_exams"
                :key="exam.exam_id"
                class="list-group-item border-left-0 border-right-0"
              >
                <div
                  class="d-flex justify-content-between align-items-start mb-1"
                >
                  <div class="font-weight-600 text-dark">
                    {{ exam.question_package_title || exam.description || "-" }}
                  </div>
                  <span class="badge" :class="badgeClass(exam.exam_state)">
                    {{ examStateLabel(exam.exam_state) }}
                  </span>
                </div>
                <div class="text-muted small mb-1">
                  {{ exam.block_name || "-" }}
                </div>
                <div class="small text-dark">
                  {{ dateclockFormat(exam.date_start) }} -
                  {{ dateclockFormat(exam.date_end) }}
                </div>
                <div
                  v-if="
                    exam.description &&
                    exam.description !== exam.question_package_title
                  "
                  class="small text-muted mt-1"
                >
                  {{ exam.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="canViewStudentAnswerStats" class="row">
      <div class="col-lg-12">
        <div class="panel border-0">
          <div
            class="panel-heading d-flex justify-content-between align-items-center"
          >
            <h4 class="panel-title">
              Analisis Soal Per Blok
              <small v-if="selectedBlockName" class="ml-2">
                {{ selectedBlockName }}
              </small>
            </h4>
            <button
              v-if="selectedBlockName"
              type="button"
              class="btn btn-sm btn-default"
              @click="clearSelectedBlock"
            >
              Reset
            </button>
          </div>
          <div class="panel-body">
            <div v-if="!selectedBlockName" class="text-center text-muted py-4">
              Klik salah satu blok pada grafik untuk melihat soal tersulit dan
              termudah.
            </div>
            <div v-else-if="loadingBlockDifficulty" class="text-center text-muted py-4">
              Memuat analisis blok...
            </div>
            <div v-else class="row">
              <div class="col-lg-6">
                <h5 class="mb-3">Soal Dengan Persentase Salah Tertinggi</h5>
                <div ref="hardestQuestionsChart" style="min-height: 420px"></div>
              </div>
              <div class="col-lg-6">
                <h5 class="mb-3">Soal Dengan Persentase Termudah</h5>
                <div ref="easiestQuestionsChart" style="min-height: 420px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import userData from "../plugins/userData";
import formatting from "@/plugins/formatting";
import Highcharts from "highcharts";
import drilldown from "highcharts/modules/drilldown";
import exporting from "highcharts/modules/exporting";
import exportingExcel from "highcharts/modules/export-data";
import accessibility from "highcharts/modules/accessibility";
import seriesLabel from "highcharts/modules/series-label";

drilldown(Highcharts);
exporting(Highcharts);
exportingExcel(Highcharts);
accessibility(Highcharts);
seriesLabel(Highcharts);

export default {
  mixins: [userData, formatting],
  name: "DashboardPage",
  data() {
    return {
      total_questions: 0,
      total_reviewed: 0,
      total_unreviewed: 0,
      total_question_package: 0,
      total_draft_questions: 0,
      total_submitted_questions: 0,
      total_active_exams: 0,
      total_upcoming_exams: 0,
      block_data: [],
      recent_exams: [],
      selectedBlockId: "",
      selectedBlockName: "",
      loadingBlockDifficulty: false,
      hardestQuestions: [],
      easiestQuestions: [],
    };
  },
  computed: {
    total_review_scope() {
      return this.total_reviewed + this.total_unreviewed;
    },
    review_progress() {
      if (!this.total_review_scope) {
        return 0;
      }

      const progress =
        (this.total_reviewed / this.total_review_scope) * 100;

      if (progress >= 100) {
        return 100;
      }

      return Number(progress.toFixed(2));
    },
    canViewStudentAnswerStats() {
      return Array.isArray(this.userLevel) && this.userLevel.includes("Admin");
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios
        .get("/v1/dashboard/", {
          headers: {
            "X-Token": this.userToken,
          },
        })
        .then((response) => {
          this.block_data = response.data.total_block || [];
          this.recent_exams = response.data.recent_exams || [];
          this.total_questions = parseInt(
            response.data.total_questions?.value || 0
          );
          this.total_reviewed = parseInt(
            response.data.total_reviewed?.value || 0
          );
          this.total_unreviewed = parseInt(
            response.data.total_unreviewed?.value || 0
          );
          this.total_question_package = parseInt(
            response.data.total_question_package?.value || 0
          );
          this.total_draft_questions = parseInt(
            response.data.total_draft_questions?.value || 0
          );
          this.total_submitted_questions = parseInt(
            response.data.total_submitted_questions?.value || 0
          );
          this.total_active_exams = parseInt(
            response.data.total_active_exams?.value || 0
          );
          this.total_upcoming_exams = parseInt(
            response.data.total_upcoming_exams?.value || 0
          );

          this.renderBarBlock();
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.message;
        });
    },
    fetchBlockDifficulty(block) {
      if (!this.canViewStudentAnswerStats || !block?.block_name) {
        return;
      }

      this.selectedBlockId = block.block_id || "";
      this.selectedBlockName = block.block_name || "";
      this.loadingBlockDifficulty = true;

      axios
        .get("/v1/dashboard/question-difficulty", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            block_id: this.selectedBlockId,
            block_name: this.selectedBlockName,
          },
        })
        .then((response) => {
          this.hardestQuestions = response.data.hardest_questions || [];
          this.easiestQuestions = response.data.easiest_questions || [];
          this.loadingBlockDifficulty = false;
          this.$nextTick(() => {
            this.renderDifficultyCharts();
          });
        })
        .catch((error) => {
          this.loadingBlockDifficulty = false;
          this.error = error.message;
          this.hardestQuestions = [];
          this.easiestQuestions = [];
        });
    },
    clearSelectedBlock() {
      this.selectedBlockId = "";
      this.selectedBlockName = "";
      this.hardestQuestions = [];
      this.easiestQuestions = [];
    },
    renderDifficultyCharts() {
      this.renderDifficultyChart({
        target: this.$refs.hardestQuestionsChart,
        title: null,
        emptyText: "Belum ada data jawaban mahasiswa pada blok ini.",
        metricKey: "incorrect_percentage",
        metricLabel: "Persentase Salah",
        color: "#f59c1a",
        chartData: this.hardestQuestions,
      });

      this.renderDifficultyChart({
        target: this.$refs.easiestQuestionsChart,
        title: null,
        emptyText: "Belum ada data jawaban mahasiswa pada blok ini.",
        metricKey: "correct_percentage",
        metricLabel: "Persentase Benar",
        color: "#49b6d6",
        chartData: this.easiestQuestions,
      });
    },
    renderDifficultyChart({
      target,
      title,
      emptyText,
      metricKey,
      metricLabel,
      color,
      chartData,
    }) {
      if (!target) {
        return;
      }

      Highcharts.chart(target, {
        chart: {
          type: "bar",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: title,
        },
        xAxis: {
          categories: chartData.map(
            (item) => item.question_code || "Tanpa Kode"
          ),
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: metricLabel,
          },
          labels: {
            format: "{value}%",
          },
        },
        legend: {
          enabled: false,
        },
        lang: {
          noData: emptyText,
        },
        tooltip: {
          formatter: function () {
            const meta = this.point.meta || {};
            return [
              `<b>${meta.question_code || "-"}</b>`,
              `${metricLabel}: ${this.y}%`,
              `Total Jawaban: ${meta.total_answers || 0}`,
              `Vignet: ${meta.vignet ? String(meta.vignet).slice(0, 160) : "-"}`,
            ].join("<br>");
          },
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{y}%",
            },
          },
        },
        series: [
          {
            name: metricLabel,
            color,
            data: chartData.map((item) => ({
              y: parseFloat(item[metricKey]) || 0,
              meta: item,
            })),
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
          },
        },
      });
    },
    truncateVignet(value) {
      if (!value) {
        return "-";
      }

      const text = String(value).trim();
      if (text.length <= 120) {
        return text;
      }

      return `${text.slice(0, 120)}...`;
    },
    badgeClass(state) {
      const classes = {
        active: "badge-success",
        upcoming: "badge-warning",
        finished: "badge-secondary",
      };

      return classes[state] || "badge-secondary";
    },
    examStateLabel(state) {
      const labels = {
        active: "Aktif",
        upcoming: "Terdekat",
        finished: "Selesai",
      };

      return labels[state] || "Unknown";
    },
    renderBarBlock() {
      Highcharts.chart(this.$refs.barBlock, {
        chart: {
          type: "bar",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Soal",
          },
          labels: {
            formatter: function () {
              return this.value !== 0 ? this.value : "0";
            },
          },
        },
        legend: {
          enabled: false,
        },
        lang: {
          noData: "Belum ada data soal untuk ditampilkan",
        },
        noData: {
          style: {
            fontWeight: "500",
            fontSize: "14px",
          },
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            cursor: this.canViewStudentAnswerStats ? "pointer" : "default",
            point: {
              events: {
                click: (event) => {
                  this.fetchBlockDifficulty(event.point.options.meta);
                },
              },
            },
            dataLabels: {
              enabled: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.point.name +
              "</b><br>Jumlah Soal : " +
              Highcharts.numberFormat(this.y, 0, ",", ".")
            );
          },
        },
        series: [
          {
            name: "Block",
            data: this.block_data.map((data) => ({
              name: data.block_name || "Tanpa Blok",
              y: parseInt(data.value),
              meta: {
                block_id: data.block_id || "",
                block_name: data.block_name || "",
              },
            })),
            colorByPoint: true,
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
          },
        },
      });
    },
  },
};
</script>
